import React from "react";

function Reviews() {
  return (
    <div className=" p-1 min-h-[70vh] py-10 flex flex-col items-center gap-16 md:gap-20 relative z-50 w-11/12">
      <p className="text-2xl md:text-3xl font-semibold md:text-left text-center">
        Here’s what our users are saying
      </p>
      <div className="flex flex-wrap items-center justify-center gap-10 w-full overflow-hidden">
        <div className="md:w-[400px] w-[350px] h-[290px] md:h-[340px] rev-1 relative cursor-pointer">
          <div className="md:w-[380px] w-[330px] h-[270px] md:h-[320px] absolute top-0 right-0 bg-rev-1 border-2 border-primary bg-primary"></div>
          <div className="md:w-[380px] w-[330px] h-[270px] md:h-[320px] absolute bottom-0 left-0 z-20 flex flex-col gap-8 p-4 md:p-8 bg-white border-2 p-rev-1 border-primary">
            <div className="flex items-start gap-4">
              <div className="h-14 w-14 bg-[url(https://images.unsplash.com/photo-1615813967515-e1838c1c5116)] bg-center bg-cover rounded-full"></div>
              <div>
                <p className="text-base font-semibold">Andrew Lamp</p>
                <p className="text-[10px] font-semibold text-black/50">
                  New York, USA
                </p>
              </div>
            </div>
            <div className="">
              <p className="text-sm tracking-wide font-medium">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
          </div>
        </div>
        <div className="md:w-[400px] w-[350px] h-[290px] md:h-[340px] relative">
          <div className="md:w-[380px] w-[330px] h-[270px] md:h-[320px] absolute top-0 right-0 bg-[#E77627]"></div>
          <div className="md:w-[380px] w-[330px] h-[270px] md:h-[320px] absolute bottom-0 left-0 z-20 flex flex-col gap-8 p-4 md:p-8 bg-white border-2 border-[#E77627]">
            <div className="flex items-start gap-4">
              <div className="h-14 w-14 bg-[url(https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e)] bg-center bg-cover rounded-full"></div>
              <div>
                <p className="text-base font-semibold">Jane Torch</p>
                <p className="text-[10px] font-semibold text-black/50">
                  Ontario, Canada
                </p>
              </div>
            </div>
            <div className="">
              <p className="text-sm tracking-wide font-medium">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
          </div>
        </div>
        <div className="md:w-[400px] w-[350px] h-[290px] md:h-[340px] relative">
          <div className="md:w-[380px] w-[330px] h-[270px] md:h-[320px] absolute top-0 right-0 bg-[#56737f]"></div>
          <div className="md:w-[380px] w-[330px] h-[270px] md:h-[320px] absolute bottom-0 left-0 z-20 flex flex-col gap-8 p-4 md:p-8 bg-white border-2 border-[#56737f]">
            <div className="flex items-start gap-4">
              <div className="h-14 w-14 bg-[url(https://images.unsplash.com/photo-1531746020798-e6953c6e8e04)] bg-center bg-cover rounded-full"></div>
              <div>
                <p className="text-base font-semibold">Halimah Duru</p>
                <p className="text-[10px] font-semibold text-black/50">
                  Abuja, Nigeria
                </p>
              </div>
            </div>
            <div className="">
              <p className="text-sm tracking-wide font-medium">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviews;
